<h2 class="tw-mt-6 tw-mb-2 tw-pb-2.5">{{ "sessionTimeoutHeader" | i18n }}</h2>

<div class="tw-max-w-lg">
  <bit-session-timeout-settings />
</div>
